import { Button, Flex, Layout } from 'antd'
import React, { useMemo } from 'react'
import CustomRadioButton from 'src/app/shared/components/common/radio-button'
import { useAllTransactionContext } from './index.context'
import { Controller, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import AllTransactionForm from './components/AllTransactionForm'
import AchForm from './components/AchForm'
import CheckForm from './components/CheckForm'
import { isEmpty } from 'lodash'
import './index.styles.scss'
import { BlackResetIcon, ResetIconDisabled, WhiteSearchIcon } from 'src/assets/icons'

const AllTransactionContent: React.FC = () => {
  const { form, options, loading, gettingData, hasRestoredFilters, onSubmit, onReset } = useAllTransactionContext()
  const { transactionOptions } = useMemo(() => options, [options])
  const { control, formState, handleSubmit } = useMemo(() => form, [form])
  const { t } = useTranslation()
  const transactionType = useWatch({
    control,
    name: 'transactionType',
  })
  const { errors, isValid, isDirty } = useMemo(() => formState, [formState])
  const shouldEnableReset = isDirty || hasRestoredFilters

  return (
    <Layout.Content
      className='all-transaction-container'
      style={{
        padding: '24px 24px 0px 24px',
        flex: 1,
      }}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{
          height: '100%',
        }}
      >
        <Flex style={{ flexDirection: 'column', gap: 24, height: '100%' }}>
          <Controller
            control={control}
            name={'transactionType'}
            render={({ field, fieldState }) => (
              <CustomRadioButton
                value={field.value}
                onChange={field.onChange}
                label={t('AllTransactions:title.transaction_type')}
                options={transactionOptions}
              />
            )}
          />
          <div
            style={{
              flex: 1,
              paddingLeft: 2,
              paddingRight: 2,
            }}
          >
            <div style={{ display: transactionType === transactionOptions[0].value ? 'block' : 'none' }}>
              <AllTransactionForm />
            </div>
            <div style={{ display: transactionType === transactionOptions[1].value ? 'block' : 'none' }}>
              <AchForm />
            </div>
            <div style={{ display: transactionType === transactionOptions[2].value ? 'block' : 'none' }}>
              <CheckForm />
            </div>
          </div>
          <Flex
            style={{
              justifyContent: 'flex-end',
              gap: 24,
            }}
            className='button-group'
          >
            <Button
              type='default'
              className='new-account-cancel-button'
              icon={shouldEnableReset ? <BlackResetIcon /> : <ResetIconDisabled />}
              disabled={!shouldEnableReset}
              onClick={onReset}
            >
              {t('common:reset')}
            </Button>
            <Button
              type='primary'
              className='new-account-button'
              htmlType='button'
              disabled={!isValid || !isEmpty(errors) || loading || gettingData}
              onClick={handleSubmit(onSubmit)}
              loading={loading}
              icon={<WhiteSearchIcon />}
            >
              {t('common:search')}
            </Button>
          </Flex>
        </Flex>
      </form>
    </Layout.Content>
  )
}

export default AllTransactionContent
